<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <span class="title">Import Trades File</span>
      </v-card-title>
      <v-container fluid>
      <v-layout wrap align-center justify-center fill-height>
        <v-flex xs12>
          <v-select
            v-model="exchange"
            :items="configs"
            prepend-icon="fas fa-coins"
            menu-props="auto"
            hide-details
            label="Exchange"
            item-text="name"
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Select Trades File"
            @click="pickFile"
            v-model="fileName"
            clear-icon="mdi-close-circle"
            clearable
            prepend-icon="attach_file"
            @click:clear="clearMessage"
            style="cursor: pointer"
          ></v-text-field>
          <input
            type="file"
            style="display: none"
            accept="text/plain"
            ref="inputFile"
            @change="onFilePicked"
          >
        </v-flex>
        <v-btn
          :loading="loading"
          :disabled="!exchange || !fileData"
          color="blue-grey"
          class="white--text"
          @click="onUpload"
        >
          Upload
          <v-icon right dark>cloud_upload</v-icon>
        </v-btn>
      </v-layout>
      </v-container>
    </v-card>
    <div>
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline lighten-2" primary-title>Result</v-card-title>
          <div v-for="(item,i) in resultData" :key="i">
            <v-card-text>
              <b>Account ID :</b>
              {{item.accountId}}
              <br>
              <b>Inserted :</b>
              {{item.insertedCount}}
            </v-card-text>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="dialog = false">CLOSE</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MessageDialog from '../../libs/message-dialog/'
import Alert from '../../libs/alert'
export default {
  data() {
    return {
      exchange: undefined,
      fileName: null,
      fileData: undefined,
      disable: false,
      loading: false,
      dialog: false,
      resultData: null,
      configs: [{
        name: 'Coinbene',
        method: 'import-coinbene',
        accounts: [
          'sales_coinbene_1',
          'sales_coinbene_2',
          'sales_coinbene_usdtbtc_1'
        ]
      }, {
        name: 'Coinone',
        method: 'import-coinone',
        accounts: [
          'sales_coinone_1',
          'sales_coinone_btckrw_1'
        ]
      }]
    }
  },
  methods: {
    pickFile() {
      this.$refs.inputFile.click()
    },
    async onFilePicked(e) {
      try {
        const files = e.target.files
        this.fileName = files[0].name
        const data = await this.readFileContent(files[0])
        this.fileData = data
      } catch (error) {
        console.error(error)
      }
    },
    readFileContent(file) {
      const reader = new FileReader()
      return new Promise((resolve, reject) => {
        reader.onload = event => resolve(event.target.result)
        reader.onerror = error => reject(error)
        reader.readAsText(file)
      })
    },
    clearMessage() {
      this.fileName = null
      this.fileData = undefined
    },
    async onUpload() {
      this.loading = true
      const { method, accounts } = this.exchange
      try {
        const result = await MongoService.api.historicalTradeExecutions({
          method,
          accounts,
          csvText: this.fileData
        })
        await Alert.success({
          message: 'Data of ' + this.fileName + ' is updated'
        })
        console.log(result)
        this.resultData = result
        this.dialog = true
        this.loading = false
        this.clearMessage()
      } catch (error) {
        MessageDialog.showErrorMessage({ text: error.toString() })
        console.error(error)
        this.dialog = false
        this.loading = false
        this.clearMessage()
      }
    }
  }
}
</script>